import { render, staticRenderFns } from "./VisitorRecordsStep.vue?vue&type=template&id=7beea298&scoped=true"
import script from "./VisitorRecordsStep.vue?vue&type=script&lang=js"
export * from "./VisitorRecordsStep.vue?vue&type=script&lang=js"
import style0 from "./VisitorRecordsStep.vue?vue&type=style&index=0&id=7beea298&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beea298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7beea298')) {
      api.createRecord('7beea298', component.options)
    } else {
      api.reload('7beea298', component.options)
    }
    module.hot.accept("./VisitorRecordsStep.vue?vue&type=template&id=7beea298&scoped=true", function () {
      api.rerender('7beea298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeVisitReport/components/Step/VisitorRecordsStep.vue"
export default component.exports